import { render } from "./NewsVue.vue?vue&type=template&id=284ee40e"
import script from "./NewsVue.vue?vue&type=script&lang=js"
export * from "./NewsVue.vue?vue&type=script&lang=js"

import "./NewsVue.vue?vue&type=style&index=0&id=284ee40e&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__